<template>

	<div class="relative px-6 py-5 bg-white">

		<!-- {{ hasData }} -->

		<div
				class="flex"
				:style="headerPaddingRight ? { paddingRight: headerPaddingRight } : null">

			<div
				:class="{ 'mr-5': ($slots['headerRight'] || []).length > 0 }"
			>
				<h3 class="mb-0 text-2xl">{{ name }}</h3>
				<small class="block mb-6 text-gray-500">{{ instruction }}</small>
			</div>

			<slot name="headerRight" class="ml-auto" />

		</div>


				<slot />

	</div>

</template>

<script>

export default {
	name: 'dashboard-plugin',

	props: {
		name: String,
		instruction: String,
		headerPaddingRight: String,
		loading: {
			type: Number,
			default: 1
		},
		loadedFirstTime: {
			type: Boolean,
			default: false,
		},
		hasData: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {

		}
	},

	async mounted()
	{

	},

	methods: {

	},

	watch: {

	},
}
</script>

<style lang="scss" scoped>

</style>
